/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../models/AaiChannelItem';
import { AaiCorrelationId } from '../models/AaiCorrelationId';
import { AaiHeaderItem } from '../models/AaiHeaderItem';
import { AaiMessage } from '../models/AaiMessage';
import { AaiMessageBindings } from '../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../models/AaiParameter';
import { AaiServerBindings } from '../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../models/AaiServerBindingsDefinition';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { IVisitor } from '../../core/visitors/IVisitor';

/**
 * A node visitor for the AsyncAPI data model.
 * 
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 */
export interface IAaiVisitor extends IVisitor {
    visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow);

    visitChannelItem(node : AaiChannelItem);

    visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow);

    visitComponents(node : Components);

    visitCorrelationId(node : AaiCorrelationId);

    visitHeaderItem(node : AaiHeaderItem);

    visitImplicitOAuthFlow(node : ImplicitOAuthFlow);

    visitMessage(node : AaiMessage);

    visitMessageTrait(node : AaiMessageTrait);

    visitMessageTraitDefinition(node : AaiMessageTraitDefinition);

    visitOAuthFlows(node : OAuthFlows);

    visitOperationTrait(node : AaiOperationTrait);

    visitOperationTraitDefinition(node : AaiOperationTraitDefinition);

    visitPasswordOAuthFlow(node : PasswordOAuthFlow);

    visitServer(node : Server);

    visitServerVariable(node : ServerVariable);

    visitAaiParameter(node : AaiParameter);

    visitServerBindings(node : AaiServerBindings);

    visitServerBindingsDefinition(node : AaiServerBindingsDefinition);

    visitOperationBindings(node : AaiOperationBindings);

    visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition);

    visitMessageBindings(node : AaiMessageBindings);

    visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition);

    visitChannelBindings(node : AaiChannelBindings);

    visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition);
}


